import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from 'App/store/rootReducer';

import {LAND_UNIT_TOOLTIP_TYPE} from './constants';

type TLandUnitTooltipsSlice = {
  isLandUnitTooltipsEnabled: boolean;
  isRecentOperationEnabled: boolean;
  tooltipType: LAND_UNIT_TOOLTIP_TYPE | null;
};

const initialState: TLandUnitTooltipsSlice = {
  isLandUnitTooltipsEnabled: false,
  isRecentOperationEnabled: false,
  tooltipType: LAND_UNIT_TOOLTIP_TYPE.RECENT_OPERATIONS,
};

const landUnitTooltipsSlice = createSlice({
  name: 'landUnitTooltips',
  initialState,
  reducers: {
    enableLandUnitTooltips: state => {
      state.isLandUnitTooltipsEnabled = true;
    },
    disableLandUnitTooltips: state => {
      state.isLandUnitTooltipsEnabled = false;
    },
    enableRecentOperationTooltips: state => {
      state.isRecentOperationEnabled = true;
    },
    disableRecentOperationTooltips: state => {
      state.isRecentOperationEnabled = false;
    },
    toggleLandUnitTooltipType: (
      state,
      {payload}: PayloadAction<LAND_UNIT_TOOLTIP_TYPE | null>,
    ) => {
      state.tooltipType = state.tooltipType !== payload ? payload : null;
    },
  },
});

export const selectIsLandUnitTooltipsEnabled = (state: RootState): boolean =>
  state.map2DEntities.landUnitTooltips.isLandUnitTooltipsEnabled;
export const selectIsRecentOperationTooltipsEnabled = (
  state: RootState,
): boolean => state.map2DEntities.landUnitTooltips.isRecentOperationEnabled;
export const selectLandUnitTooltipType = (
  state: RootState,
): LAND_UNIT_TOOLTIP_TYPE | null =>
  state.map2DEntities.landUnitTooltips.tooltipType;

export const {
  enableLandUnitTooltips,
  disableLandUnitTooltips,
  enableRecentOperationTooltips,
  disableRecentOperationTooltips,
  toggleLandUnitTooltipType,
} = landUnitTooltipsSlice.actions;

export default landUnitTooltipsSlice.reducer;
